export default {
  try_again: 'Try Again',
  unauthorized: 'Unauthorized',
  unauthenticated: 'Unauthenticated',
  unauthenticated_desc: 'You need to be authenticated to access this page',
  login: 'Login',
  go_to_home_page: 'Go to Home Page',
  general_error: 'Something went wrong!',
  failed_to_load_data: 'Failed to load data!',
  not_found_title: 'This Page Does Not Exist',
  application_not_found: "Sorry, we couldn't access the application ID",
  your_request_failed: 'Looks like Your request failed for some reason!',
  not_found_desc: 'Sorry, the website address you entered is not correct',
  something_went_wrong: 'Something went wrong!',
  unexpected_error: 'The application has encountered an unexpected error.',
  otp_trials_exceeded:
    'You have reached the maximum number of wrong OTP trials, you can try again after {{minutes}} minutes from now.',

  // API error codes
  DocumentNotFound: 'Document not found',
  MP000: 'Service not available from origin',
  MP001: 'Invalid Captcha',
  MP002: 'Customer not found',
  MP003: 'Not valid parameter',
  MP004: 'Not valid Application Effective date',
  MP006: 'Application not found',
  MP007: 'UnValid scheme verification type',
  MP008: 'UnAuthorized user',
  MP009: 'Quotation expired',
  MP010: 'Wrong IBAN format',
  MP011: 'Unsupported payment Method',
  MP012: 'No Existed Field with Name ({0}) with Value ({1})',
  MP013: 'Application is Expired',
  MP014: 'Application is not valid',
  MP015: 'Mobile number already used with another Policy Holder',
  MP016: 'Sponsor Number is required',
  MP017:
    'The Sponsor Number entered is invalid, kindly check the input and try again',
  MP018: 'Date of Birth is required',
  MP019:
    'The Date of Birth entered is invalid, kindly check the input and try again',
  MP020: 'National ID/Iqama Number is required',
  MP021: 'The ID entered is invalid, kindly check the input and try again',
  MP022:
    "The input entered aren't matching with the data at the National Information Center, kindly check the input and try again",
  MP023: 'Age can not be less than {0} years',
  MP024:
    'Minimum age for a policy holder as a visitor cannot be less than {0} years',
  MP025: 'InValid Policy Holder Profession details',
  MP026: 'InValid Declaration Questions details',
  MP027: 'InValid Previous/Existed Policy details',
  MP028: 'Wrong OTP',
  MP029: 'Invalid Invoice Amount',
  MP030: 'Invalid Declarations',
  MP031: 'Invalid InsuranceCompany ID',
  MP032:
    'We apologize for the inconvenience, but we cannot proceed in the request as the provided mobile number is not owned by the provided ID/Iqama Number. Kindly provide a mobile number owned by the provided ID/Iqama Number',
  MP033: 'Application invoice not found',
  MP034: 'Already Retrieve Success action for this process in progress',
  MP038: 'Total number of places can not be more than {0}',
  MP039: 'Place Type out of range',
  MP040: 'Policy not found',
  MP042: 'Payment not found',
  MP043: 'Bill Details not found',
  MP044: 'Not valid mobile number',
  PolicyHolderIsBlocked:
    'Unfortunately, we cannot proceed in processing your request. For more information you can contact customer service',
  specialty_required: 'Specialty required',
  birth_date_not_correct_error:
    'Please make sure the ID Number and date of birth are correct',
  national_address_not_found: 'National Address not found',
  'national-address-not-found': 'National Address not found',
  national_address_already_exists:
    'A national address already exists for this request.',
  cancellation_request_already_exists:
    'A cancellation request is already in progress for this policy.',
  BUILDING_NUMBER_INVALID_LENGTH: 'Building number cannot exceed 4 digits',
  city_not_found_in_address: 'City missed in your address details',
  district_not_found_in_address: 'District missed in your address details',
  quotation_not_found: 'Quote Reference not found',
  mobile_number_notVerified: 'The mobile number has not been verified',
  failed_to_download_file: 'The file could not be downloaded or does not exist',
  REDEMPTION_VALIDATION_ERROR: 'Minimum balance points required: {0}',
  T071: 'Invoice has an active payment in progress. Please wait for the current payment to complete or contact customer service.',
  O002: 'Wrong OTP',
  O005: 'OTP has been expired.',
  O003: 'OTP max number of retries exceeded',
  IBAN_VERIFICATION_ERROR:
    'IBAN verification failed, please check the IBAN and try again',
  USER_BLOCKED:
    "You have exceeded the allowed number of attempts to verify your IBAN.\nPlease wait {{duration}} before trying again.\nKindly ensure that the IBAN entered is registered under the policyholder's name",
  INTERNAL_SERVER_ERROR: 'Something went wrong',
  policy_related_to_other_identity:
    'Policy is related to other identity number',
  invalid_retroactive_date: 'Retroactive date cannot be in the future',
} as const
